module.exports = __webpack_public_path__ + "static/sinner-gray-da65ed10588ce4615582ae365c9d79b7.png";